import React from "react";
import { motion } from "framer-motion";

// Splits text into lines and reveals each with a mask.
// Provide `lines` as an array of strings/nodes.
export function RevealLines({ lines = [], delay = 0, className = "", lineClassName = "", stagger = 0.09, testId }) {
    return (
        <span className={className} data-testid={testId}>
            {lines.map((line, i) => (
                <span key={i} className="mask-line">
                    <motion.span
                        className={`block ${lineClassName}`}
                        initial={{ y: "110%" }}
                        animate={{ y: "0%" }}
                        transition={{
                            duration: 0.9,
                            delay: delay + i * stagger,
                            ease: [0.65, 0, 0.35, 1],
                        }}
                    >
                        {line}
                    </motion.span>
                </span>
            ))}
        </span>
    );
}

// In-view fade-up with optional stagger of direct children.
export function FadeUp({ children, delay = 0, y = 32, duration = 0.7, className = "", once = true }) {
    return (
        <motion.div
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once, amount: 0.2 }}
            transition={{ duration, delay, ease: [0.22, 1, 0.36, 1] }}
        >
            {children}
        </motion.div>
    );
}
